import { render } from "./LoginCallback.vue?vue&type=template&id=6e4d575f"
import script from "./LoginCallback.vue?vue&type=script&lang=ts"
export * from "./LoginCallback.vue?vue&type=script&lang=ts"
script.render = render

export default script